<script setup lang="ts">
const props = defineProps({
	isShow: {
		type: Boolean,
		default: false,
	},
	identifier: {
		type: [String, Number, Boolean],
		default: undefined,
	},
});

const emit = defineEmits<{
	(e: 'onOpen', value: boolean): void;
	(e: 'onFetchData', value: InfiniteLoadingEvent): void;
	(e: 'onClose'): void;
}>();

const isOpenDialog = computed({
	get: () => props.isShow,
	set: (value) => {
		emit('onOpen', value);
	},
});

function handleFetchData($state: InfiniteLoadingEvent) {
	emit('onFetchData', $state);
}

function handleClose() {
	isOpenDialog.value = false;
	emit('onClose');
}
</script>

<template>
	<BaseDialog :is-show="isOpenDialog" @on-close="handleClose">
		<template #header>
			<slot name="header" />
		</template>

		<template #content>
			<div class="infinite-dialog-content">
				<slot :close="handleClose" />
				<BaseInfiniteLoading @infinite="handleFetchData">
					<template #complete>
						<slot name="complete"><span /></slot>
					</template>
					<template #spinner>
						<slot name="spinner" />
					</template>
				</BaseInfiniteLoading>
			</div>
		</template>
	</BaseDialog>
</template>

<style lang="scss" scoped>
.infinite-dialog-content {
	width: 100%;
	max-height: rem(512);
	display: flex;
	flex-direction: column;
}
</style>
